module.exports = __webpack_public_path__ + "img/without_reportlake.e830cc19.png";